import { render, staticRenderFns } from "./AutoOpinionDialog.vue?vue&type=template&id=20d366ee&scoped=true&"
import script from "./AutoOpinionDialog.vue?vue&type=script&lang=js&"
export * from "./AutoOpinionDialog.vue?vue&type=script&lang=js&"
import style0 from "./AutoOpinionDialog.vue?vue&type=style&index=0&id=20d366ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d366ee",
  null
  
)

export default component.exports